const AaeonDeviceFront = ({ ports }: { ports: any[] | null | undefined }) => {
  const lanPorts = ports?.filter(
    (portinterface) =>
      (portinterface?.display === true ||
        portinterface?.data?.portinterface?.display === true) &&
      (portinterface?.type === "LAN" ||
        portinterface?.data?.portinterface?.type === "LAN")
  );

  const lanOnePorts = lanPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "LAN 1" ||
      portinterface?.data?.portinterface?.display_name === "LAN 1"
  );

  const lanOnePort = lanOnePorts ? lanOnePorts[0] : null;

  let lanOneGreen = "#BABABA";
  let lanOneRed = "#BABABA";

  if (lanOnePort?.data?.portinterface?.live?.link_state === "up") {
    lanOneGreen = "#84E88E";
    lanOneRed = "#FF7A00";
  }

  const lanTwoPorts = lanPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "LAN 2" ||
      portinterface?.data?.portinterface?.display_name === "LAN 2"
  );

  const lanTwoPort = lanTwoPorts ? lanTwoPorts[0] : null;

  let lanTwoGreen = "#BABABA";
  let lanTwoRed = "#BABABA";

  if (lanTwoPort?.data?.portinterface?.live?.link_state === "up") {
    lanTwoGreen = "#84E88E";
    lanTwoRed = "#FF7A00";
  }

  const lanThreePorts = lanPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "LAN 3" ||
      portinterface?.data?.portinterface?.display_name === "LAN 3"
  );

  const lanThreePort = lanThreePorts ? lanThreePorts[0] : null;

  let lanThreeGreen = "#BABABA";
  let lanThreeRed = "#BABABA";

  if (lanThreePort?.data?.portinterface?.live?.link_state === "up") {
    lanThreeGreen = "#84E88E";
    lanThreeRed = "#FF7A00";
  }

  const lanFourPorts = lanPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "LAN 4" ||
      portinterface?.data?.portinterface?.display_name === "LAN 4"
  );

  const lanFourPort = lanFourPorts ? lanFourPorts[0] : null;

  let lanFourGreen = "#BABABA";
  let lanFourRed = "#BABABA";

  if (lanFourPort?.data?.portinterface?.live?.link_state === "up") {
    lanFourGreen = "#84E88E";
    lanFourRed = "#FF7A00";
  }

  const wanPorts = ports?.filter(
    (portinterface) =>
      (portinterface?.display === true ||
        portinterface?.data?.portinterface?.display === true) &&
      (portinterface?.type === "WAN" ||
        portinterface?.data?.portinterface?.type === "WAN")
  );

  const wanPort = wanPorts ? wanPorts[0] : null;

  let wanGreen = "#BABABA";

  if (wanPort?.data?.portinterface?.live?.link_state === "up") {
    wanGreen = "#84E88E";
  }

  const sfpPorts = ports?.filter(
    (portinterface) =>
      (portinterface?.display === true ||
        portinterface?.data?.portinterface?.display === true) &&
      (portinterface?.type === "LAN" ||
        portinterface?.data?.portinterface?.type === "LAN")
  );

  const sfpOnePorts = sfpPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "SFP 1" ||
      portinterface?.data?.portinterface?.display_name === "SFP 1"
  );

  const sfpOnePort = sfpOnePorts ? sfpOnePorts[0] : null;

  let sfpOneGreen = "#BABABA";
  let sfpOneRed = "#BABABA";

  if (sfpOnePort?.data?.portinterface?.live?.link_state === "up") {
    sfpOneGreen = "#84E88E";
    sfpOneRed = "#FF7A00";
  }

  const sfpTwoPorts = sfpPorts?.filter(
    (portinterface) =>
      portinterface?.display_name === "SFP 2" ||
      portinterface?.data?.portinterface?.display_name === "SFP 2"
  );

  const sfpTwoPort = sfpTwoPorts ? sfpTwoPorts[0] : null;

  let sfpTwoGreen = "#BABABA";
  let sfpTwoRed = "#BABABA";

  if (sfpTwoPort?.data?.portinterface?.live?.link_state === "up") {
    sfpTwoGreen = "#84E88E";
    sfpTwoRed = "#FF7A00";
  }

  return (
    <svg
      width="100%"
      height="233"
      viewBox="0 0 550 199"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 16L188 0.5L524.5 53.5L332.5 75L9 16Z" fill="#716F6F" />
      <g filter="url(#filter0_d_2520_209293)">
        <path
          d="M9 105.243V16L332.547 74.7568L524.5 53.5V152.425L332.547 179L9 105.243Z"
          fill="url(#paint0_linear_2520_209293)"
        />
        <path
          d="M9.84351 104.57V17.0105L332.396 75.5867L332.517 75.6087L332.64 75.5951L523.656 54.4421V151.691L332.584 178.143L9.84351 104.57Z"
          stroke="#999999"
          strokeWidth="1.68702"
        />
      </g>
      <path
        d="M133.895 96.7562V70.4102L225.353 88.4917V116.028L133.895 96.7562Z"
        fill="#A9A9A9"
      />
      <ellipse
        cx="4.11965"
        cy="5.43454"
        rx="4.11965"
        ry="5.43454"
        transform="matrix(0.981137 -0.193315 0.194967 0.98081 295 113.593)"
        fill="#D9D9D9"
      />
      <path
        d="M59.323 76.2963V61.2916L74.7204 64.361V79.4919L59.323 76.2963Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.337405"
      />
      <path
        d="M244.208 117.699V103.206L259.605 106.279V120.894L244.208 117.699Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.337405"
      />
      <path
        d="M267.809 122.604V107.895L283.207 110.976V125.793L267.809 122.604Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.337405"
      />
      <path
        d="M140.048 91.9777V76.5039L155.277 79.5473V95.1392L140.048 91.9777Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.506107"
      />
      <path
        d="M161.684 96.4699V80.8281L176.912 83.8677V99.6335L161.684 96.4699Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.506107"
      />
      <path
        d="M183.319 100.966V85.1485L198.548 88.1919V104.12L183.319 100.966Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.506107"
      />
      <path
        d="M204.954 105.458V89.4727L220.183 92.5161V108.619L204.954 105.458Z"
        fill="#414141"
        stroke="#D9D9D9"
        strokeWidth="0.506107"
      />
      <path
        d="M42.5952 58.0386L35.5527 59.022L37.5196 73.7734L45.387 71.8065C48.3373 67.8728 47.5123 59.022 42.5952 58.0386Z"
        fill="#7E8281"
      />
      <ellipse
        cx="37.3791"
        cy="66.3553"
        rx="4.74517"
        ry="7.74012"
        transform="rotate(-4.19759 37.3791 66.3553)"
        fill="#D9D9D9"
      />
      <ellipse
        cx="37.2708"
        cy="66.4014"
        rx="3.73703"
        ry="6.69575"
        transform="rotate(-4.19759 37.2708 66.4014)"
        fill="#A4A0A0"
      />
      <path
        d="M86.0967 70.6502L86.0967 66.0765L101.274 68.9626L101.274 73.5363L86.0967 70.6502Z"
        fill="#4485D1"
        stroke="#CAC5C5"
        strokeWidth="0.337405"
      />
      <path
        d="M86.0967 80.7554L86.0967 76.1816L101.274 79.0678L101.274 83.6415L86.0967 80.7554Z"
        fill="#4485D1"
        stroke="#CAC5C5"
        strokeWidth="0.337405"
      />
      <path
        d="M9.84351 104.57V17.0105L332.396 75.5867L332.517 75.6087L332.64 75.5951L523.656 54.4421V151.691L332.584 178.143L9.84351 104.57Z"
        fill="url(#paint1_linear_2520_209293)"
        stroke="#999999"
        strokeWidth="1.68702"
      />
      <path
        d="M303.5 88.9796V151.026C303.5 154.543 300.245 157.156 296.811 156.396L111.478 115.347C108.959 114.789 107.167 112.556 107.167 109.977V54.2296C107.167 50.7858 110.296 48.1891 113.681 48.8238L299.014 83.5738C301.615 84.0615 303.5 86.3329 303.5 88.9796Z"
        fill="url(#paint2_linear_2520_209293)"
        stroke="#999999"
      />
      <path
        d="M303.7 88.9802V150.232C303.7 153.877 300.326 156.586 296.767 155.798L112.267 114.933C109.658 114.355 107.8 112.041 107.8 109.368V54.4131C107.8 50.8444 111.042 48.1534 114.55 48.8106L299.05 83.3777C301.746 83.8829 303.7 86.237 303.7 88.9802Z"
        fill="url(#paint3_linear_2520_209293)"
        stroke="#3C3636"
        strokeWidth="0.6"
      />
      <path
        id="SFP_2_green"
        d="M134.234 69.487C134.374 70.8606 133.597 72.0652 132.498 72.1776C131.4 72.29 130.395 71.2676 130.254 69.894C130.114 68.5205 130.891 67.3159 131.99 67.2035C133.088 67.0911 134.093 68.1135 134.234 69.487Z"
        fill={sfpTwoGreen}
      />
      <path
        id="SFP_2_red"
        d="M134.234 80.368C134.374 81.7416 133.597 82.9462 132.498 83.0585C131.4 83.1709 130.395 82.1486 130.254 80.775C130.114 79.4015 130.891 78.1969 131.99 78.0845C133.088 77.9721 134.093 78.9945 134.234 80.368Z"
        fill={sfpTwoRed}
      />
      <path
        id="SFP_1_green"
        d="M144.234 71.487C144.374 72.8606 143.597 74.0652 142.498 74.1776C141.4 74.29 140.395 73.2676 140.254 71.894C140.114 70.5205 140.891 69.3159 141.99 69.2035C143.088 69.0911 144.093 70.1135 144.234 71.487Z"
        fill={sfpOneGreen}
      />
      <path
        id="SFP_1_red"
        d="M144.234 82.368C144.374 83.7416 143.597 84.9462 142.498 85.0585C141.4 85.1709 140.395 84.1486 140.254 82.775C140.114 81.4015 140.891 80.1969 141.99 80.0845C143.088 79.9721 144.093 80.9945 144.234 82.368Z"
        fill={sfpOneRed}
      />
      <path
        id="LAN_1_green"
        d="M164.234 75.487C164.374 76.8606 163.597 78.0652 162.498 78.1776C161.4 78.29 160.395 77.2676 160.254 75.894C160.114 74.5205 160.891 73.3159 161.99 73.2035C163.088 73.0911 164.093 74.1135 164.234 75.487Z"
        fill={lanOneGreen}
      />
      <path
        id="LAN_1_red"
        d="M164.234 86.368C164.374 87.7416 163.597 88.9462 162.498 89.0585C161.4 89.1709 160.395 88.1486 160.254 86.775C160.114 85.4015 160.891 84.1969 161.99 84.0845C163.088 83.9721 164.093 84.9945 164.234 86.368Z"
        fill={lanOneRed}
      />
      <path
        id="LAN_2_green"
        d="M174.234 77.487C174.374 78.8606 173.597 80.0652 172.498 80.1776C171.4 80.29 170.395 79.2676 170.254 77.894C170.114 76.5205 170.891 75.3159 171.99 75.2035C173.088 75.0911 174.093 76.1135 174.234 77.487Z"
        fill={lanTwoGreen}
      />
      <path
        id="LAN_2_red"
        d="M174.234 88.368C174.374 89.7416 173.597 90.9462 172.498 91.0585C171.4 91.1709 170.395 90.1486 170.254 88.775C170.114 87.4015 170.891 86.1969 171.99 86.0845C173.088 85.9721 174.093 86.9945 174.234 88.368Z"
        fill={lanTwoRed}
      />
      <path
        id="LAN_3_green"
        d="M184.234 79.487C184.374 80.8606 183.597 82.0652 182.498 82.1776C181.4 82.29 180.395 81.2676 180.254 79.894C180.114 78.5205 180.891 77.3159 181.99 77.2035C183.088 77.0911 184.093 78.1135 184.234 79.487Z"
        fill={lanThreeGreen}
      />
      <path
        id="LAN_3_red"
        d="M184.234 90.368C184.374 91.7416 183.597 92.9462 182.498 93.0585C181.4 93.1709 180.395 92.1486 180.254 90.775C180.114 89.4015 180.891 88.1969 181.99 88.0845C183.088 87.9721 184.093 88.9945 184.234 90.368Z"
        fill={lanThreeRed}
      />
      <path
        id="LAN_4_green"
        d="M194.234 81.487C194.374 82.8606 193.597 84.0652 192.498 84.1776C191.4 84.29 190.395 83.2676 190.254 81.894C190.114 80.5205 190.891 79.3159 191.99 79.2035C193.088 79.0911 194.093 80.1135 194.234 81.487Z"
        fill={lanFourGreen}
      />
      <path
        id="LAN_4_red"
        d="M194.234 92.368C194.374 93.7416 193.597 94.9462 192.498 95.0585C191.4 95.1709 190.395 94.1486 190.254 92.775C190.114 91.4015 190.891 90.1969 191.99 90.0845C193.088 89.9721 194.093 90.9945 194.234 92.368Z"
        fill={lanFourRed}
      />
      <path
        d="M204.234 83.487C204.374 84.8606 203.597 86.0652 202.498 86.1776C201.4 86.29 200.395 85.2676 200.254 83.894C200.114 82.5205 200.891 81.3159 201.99 81.2035C203.088 81.0911 204.093 82.1135 204.234 83.487Z"
        fill="#BABABA"
      />
      <path
        d="M204.234 94.368C204.374 95.7416 203.597 96.9462 202.498 97.0585C201.4 97.1709 200.395 96.1486 200.254 94.775C200.114 93.4015 200.891 92.1969 201.99 92.0845C203.088 91.9721 204.093 92.9945 204.234 94.368Z"
        fill="#BABABA"
      />
      <path
        d="M214.234 85.487C214.374 86.8606 213.597 88.0652 212.498 88.1776C211.4 88.29 210.395 87.2676 210.254 85.894C210.114 84.5205 210.891 83.3159 211.99 83.2035C213.088 83.0911 214.093 84.1135 214.234 85.487Z"
        fill="#BABABA"
      />
      <path
        d="M214.234 96.368C214.374 97.7416 213.597 98.9462 212.498 99.0585C211.4 99.1709 210.395 98.1486 210.254 96.775C210.114 95.4015 210.891 94.1969 211.99 94.0845C213.088 93.9721 214.093 94.9945 214.234 96.368Z"
        fill="#BABABA"
      />
      <path
        d="M224.234 98.368C224.374 99.7416 223.597 100.946 222.498 101.059C221.4 101.171 220.395 100.149 220.254 98.775C220.114 97.4015 220.891 96.1969 221.99 96.0845C223.088 95.9721 224.093 96.9945 224.234 98.368Z"
        fill="#BABABA"
      />
      <path
        id="WAN_green"
        d="M224.234 98.368C224.374 99.7416 223.597 100.946 222.498 101.059C221.4 101.171 220.395 100.149 220.254 98.775C220.114 97.4015 220.891 96.1969 221.99 96.0845C223.088 95.9721 224.093 96.9945 224.234 98.368Z"
        fill={wanGreen}
      />
      <path
        d="M130.512 65.3559C130.255 65.3021 130.005 65.2099 129.764 65.0795C129.525 64.9464 129.338 64.8006 129.201 64.6419L129.382 64.2898C129.512 64.437 129.679 64.5701 129.881 64.689C130.087 64.8053 130.297 64.886 130.512 64.9309C130.796 64.9903 131.008 64.9862 131.149 64.9189C131.289 64.8482 131.359 64.7312 131.359 64.5678C131.359 64.4478 131.32 64.343 131.242 64.2533C131.167 64.161 131.072 64.0828 130.958 64.019C130.847 63.9558 130.689 63.8778 130.483 63.7848C130.225 63.6676 130.016 63.5607 129.857 63.4639C129.7 63.3679 129.564 63.2429 129.45 63.0891C129.339 62.9326 129.284 62.7426 129.284 62.5193C129.284 62.3326 129.331 62.1742 129.426 62.044C129.524 61.9144 129.671 61.8251 129.866 61.776C130.062 61.7269 130.305 61.7327 130.596 61.7933C130.798 61.8356 130.997 61.9038 131.193 61.9981C131.388 62.0923 131.556 62.2041 131.697 62.3334L131.535 62.6996C131.392 62.5763 131.238 62.4743 131.075 62.3935C130.912 62.3094 130.752 62.251 130.596 62.2183C130.318 62.1604 130.109 62.1684 129.969 62.2425C129.832 62.3172 129.764 62.4362 129.764 62.5995C129.764 62.7195 129.803 62.826 129.881 62.919C129.959 63.0087 130.056 63.0872 130.17 63.1544C130.287 63.2189 130.445 63.2953 130.644 63.3836C130.902 63.5007 131.109 63.6074 131.266 63.7034C131.423 63.7995 131.556 63.9241 131.667 64.0773C131.782 64.2311 131.839 64.418 131.839 64.638C131.839 64.8214 131.79 64.9795 131.692 65.1124C131.594 65.2419 131.446 65.3309 131.247 65.3793C131.047 65.4244 130.803 65.4166 130.512 65.3559ZM135.197 65.8596V66.2946L132.735 65.7802V65.4402L134.13 64.3567C134.299 64.2254 134.414 64.106 134.472 63.9982C134.531 63.8872 134.56 63.77 134.56 63.6466C134.56 63.4633 134.497 63.3083 134.37 63.1818C134.246 63.0525 134.066 62.9634 133.831 62.9143C133.453 62.8352 133.161 62.9009 132.955 63.1113L132.622 62.7467C132.756 62.608 132.931 62.5145 133.146 62.4661C133.365 62.4185 133.608 62.4226 133.875 62.4785C134.234 62.5535 134.52 62.7014 134.732 62.9224C134.944 63.1401 135.05 63.3989 135.05 63.6989C135.05 63.8855 135.011 64.054 134.932 64.2043C134.854 64.3546 134.706 64.5136 134.487 64.6813L133.44 65.4925L135.197 65.8596Z"
        fill="white"
      />
      <path
        d="M140.512 67.3559C140.255 67.3021 140.005 67.2099 139.764 67.0795C139.525 66.9464 139.338 66.8006 139.201 66.6419L139.382 66.2898C139.512 66.437 139.679 66.5701 139.881 66.689C140.087 66.8053 140.297 66.886 140.512 66.9309C140.796 66.9903 141.008 66.9862 141.149 66.9189C141.289 66.8482 141.359 66.7312 141.359 66.5678C141.359 66.4478 141.32 66.343 141.242 66.2533C141.167 66.161 141.072 66.0828 140.958 66.019C140.847 65.9558 140.689 65.8778 140.483 65.7848C140.225 65.6676 140.016 65.5607 139.857 65.4639C139.7 65.3679 139.564 65.2429 139.45 65.0891C139.339 64.9326 139.284 64.7426 139.284 64.5193C139.284 64.3326 139.331 64.1742 139.426 64.044C139.524 63.9144 139.671 63.8251 139.866 63.776C140.062 63.7269 140.305 63.7327 140.596 63.7933C140.798 63.8356 140.997 63.9038 141.193 63.9981C141.388 64.0923 141.556 64.2041 141.697 64.3334L141.535 64.6996C141.392 64.5763 141.238 64.4743 141.075 64.3935C140.912 64.3094 140.752 64.251 140.596 64.2183C140.318 64.1604 140.109 64.1684 139.969 64.2425C139.832 64.3172 139.764 64.4362 139.764 64.5995C139.764 64.7195 139.803 64.826 139.881 64.919C139.959 65.0087 140.056 65.0872 140.17 65.1544C140.287 65.2189 140.445 65.2953 140.644 65.3836C140.902 65.5007 141.109 65.6074 141.266 65.7034C141.423 65.7995 141.556 65.9241 141.667 66.0773C141.782 66.2311 141.839 66.418 141.839 66.638C141.839 66.8214 141.79 66.9795 141.692 67.1124C141.594 67.2419 141.446 67.3309 141.247 67.3793C141.047 67.4244 140.803 67.4166 140.512 67.3559ZM143.803 64.5034V68.0034L143.318 67.9022V64.8372L142.545 64.6756V64.2406L143.803 64.5034Z"
        fill="white"
      />
      <path
        d="M162.297 67.771V71.271L161.812 71.1697V68.1047L161.039 67.9432V67.5082L162.297 67.771Z"
        fill="white"
      />
      <path
        d="M173.643 73.1171V73.5521L171.181 73.0378V72.6978L172.576 71.6142C172.746 71.483 172.86 71.3635 172.919 71.2558C172.977 71.1447 173.007 71.0276 173.007 70.9042C173.007 70.7209 172.943 70.5659 172.816 70.4393C172.692 70.3101 172.512 70.2209 172.277 70.1719C171.899 70.0928 171.607 70.1585 171.401 70.3688L171.069 70.0043C171.202 69.8656 171.377 69.7721 171.592 69.7237C171.811 69.6761 172.054 69.6802 172.321 69.7361C172.68 69.8111 172.966 69.959 173.178 70.18C173.39 70.3976 173.496 70.6565 173.496 70.9565C173.496 71.1431 173.457 71.3116 173.379 71.4619C173.3 71.6122 173.152 71.7712 172.933 71.9389L171.886 72.7501L173.643 73.1171Z"
        fill="white"
      />
      <path
        d="M182.547 73.2931C182.883 73.3966 183.139 73.5568 183.315 73.7736C183.491 73.9871 183.579 74.2322 183.579 74.5088C183.579 74.7088 183.53 74.8803 183.432 75.0232C183.335 75.1627 183.188 75.2604 182.992 75.3161C182.799 75.3693 182.563 75.3665 182.282 75.3079C182.038 75.2568 181.803 75.171 181.578 75.0507C181.352 74.927 181.168 74.7834 181.024 74.6201L181.25 74.2721C181.367 74.41 181.517 74.533 181.7 74.6412C181.883 74.7461 182.077 74.8199 182.282 74.8629C182.537 74.9161 182.734 74.9023 182.875 74.8216C183.018 74.7416 183.09 74.6049 183.09 74.4116C183.09 74.2183 183.02 74.0536 182.879 73.9176C182.739 73.7817 182.527 73.684 182.243 73.6247L181.969 73.5675V73.2175L182.83 72.3174L181.181 71.9728V71.5378L183.442 72.0102V72.3502L182.547 73.2931Z"
        fill="white"
      />
      <path
        d="M194.216 76.8118L193.565 76.6758V77.5358L193.09 77.4366V76.5766L191.186 76.1789V75.8289L192.938 73.9049L193.467 74.0153L191.788 75.8746L193.105 76.1497V75.3897L193.565 75.4858V76.2458L194.216 76.3818V76.8118Z"
        fill="white"
      />
      <path
        d="M200.255 77.0192C200.415 77.0978 200.54 77.2066 200.631 77.3457C200.723 77.4821 200.768 77.641 200.768 77.8223C200.768 78.065 200.678 78.2328 200.498 78.3259C200.321 78.4195 200.061 78.4305 199.719 78.3591L198.411 78.0859V75.2859L199.641 75.5427C199.954 75.6082 200.195 75.7226 200.365 75.8861C200.537 76.0501 200.623 76.2454 200.623 76.472C200.623 76.6187 200.589 76.7383 200.522 76.8308C200.456 76.9238 200.368 76.9866 200.255 77.0192ZM198.803 75.6917V76.5877L199.605 76.7554C199.806 76.7974 199.96 76.7922 200.067 76.7399C200.177 76.6855 200.232 76.5849 200.232 76.4383C200.232 76.2916 200.177 76.1695 200.067 76.0719C199.96 75.9722 199.806 75.9014 199.605 75.8594L198.803 75.6917ZM199.703 78.0318C199.925 78.0782 200.092 78.0757 200.204 78.0245C200.317 77.9733 200.373 77.8677 200.373 77.7077C200.373 77.3957 200.15 77.1931 199.703 77.0998L198.803 76.9117V77.8437L199.703 78.0318ZM202.306 76.0996C202.661 76.1738 202.941 76.3188 203.144 76.5347C203.348 76.7506 203.45 77.0105 203.45 77.3145C203.45 77.6185 203.348 77.8359 203.144 77.9667C202.941 78.0975 202.661 78.1258 202.306 78.0516L201.629 77.9101V78.7581L201.237 78.6763V75.8763L202.306 76.0996ZM202.295 77.7012C202.543 77.753 202.732 77.7392 202.862 77.6598C202.993 77.5777 203.058 77.4354 203.058 77.2327C203.058 77.03 202.993 76.8617 202.862 76.7278C202.732 76.5912 202.543 76.497 202.295 76.4452L201.629 76.3061V77.5621L202.295 77.7012ZM204.553 76.5689V79.3689L204.165 79.2879V76.8359L203.546 76.7067V76.3587L204.553 76.5689Z"
        fill="white"
      />
      <path
        d="M200.255 100.019C200.415 100.098 200.54 100.207 200.631 100.346C200.723 100.482 200.768 100.641 200.768 100.822C200.768 101.065 200.678 101.233 200.498 101.326C200.321 101.419 200.061 101.431 199.719 101.359L198.411 101.086V98.2859L199.641 98.5427C199.954 98.6082 200.195 98.7226 200.365 98.8861C200.537 99.0501 200.623 99.2454 200.623 99.472C200.623 99.6187 200.589 99.7383 200.522 99.8308C200.456 99.9238 200.368 99.9866 200.255 100.019ZM198.803 98.6917V99.5877L199.605 99.7554C199.806 99.7974 199.96 99.7922 200.067 99.7399C200.177 99.6855 200.232 99.5849 200.232 99.4383C200.232 99.2916 200.177 99.1695 200.067 99.0719C199.96 98.9722 199.806 98.9014 199.605 98.8594L198.803 98.6917ZM199.703 101.032C199.925 101.078 200.092 101.076 200.204 101.025C200.317 100.973 200.373 100.868 200.373 100.708C200.373 100.396 200.15 100.193 199.703 100.1L198.803 99.9117V100.844L199.703 101.032ZM202.306 99.0996C202.661 99.1738 202.941 99.3188 203.144 99.5347C203.348 99.7506 203.45 100.01 203.45 100.314C203.45 100.618 203.348 100.836 203.144 100.967C202.941 101.097 202.661 101.126 202.306 101.052L201.629 100.91V101.758L201.237 101.676V98.8763L202.306 99.0996ZM202.295 100.701C202.543 100.753 202.732 100.739 202.862 100.66C202.993 100.578 203.058 100.435 203.058 100.233C203.058 100.03 202.993 99.8617 202.862 99.7278C202.732 99.5912 202.543 99.497 202.295 99.4452L201.629 99.3061V100.562L202.295 100.701ZM205.61 102.242V102.59L203.641 102.178V101.906L204.757 101.04C204.892 100.935 204.984 100.839 205.031 100.753C205.078 100.664 205.101 100.57 205.101 100.472C205.101 100.325 205.05 100.201 204.949 100.1C204.849 99.9962 204.706 99.9249 204.518 99.8856C204.215 99.8224 203.981 99.8749 203.817 100.043L203.551 99.7516C203.658 99.6406 203.797 99.5658 203.97 99.5271C204.145 99.489 204.339 99.4923 204.553 99.537C204.84 99.597 205.069 99.7154 205.238 99.8922C205.408 100.066 205.493 100.273 205.493 100.513C205.493 100.663 205.461 100.797 205.399 100.918C205.336 101.038 205.217 101.165 205.042 101.299L204.205 101.948L205.61 102.242ZM207.732 103.065C207.525 103.022 207.326 102.948 207.132 102.844C206.942 102.737 206.792 102.621 206.682 102.494L206.827 102.212C206.931 102.33 207.065 102.436 207.226 102.532C207.391 102.625 207.559 102.689 207.732 102.725C207.959 102.772 208.128 102.769 208.241 102.715C208.353 102.659 208.409 102.565 208.409 102.435C208.409 102.339 208.378 102.255 208.315 102.183C208.255 102.109 208.179 102.047 208.088 101.995C207.999 101.945 207.872 101.882 207.708 101.808C207.502 101.714 207.335 101.629 207.207 101.551C207.082 101.475 206.973 101.375 206.882 101.252C206.793 101.126 206.749 100.974 206.749 100.796C206.749 100.646 206.787 100.52 206.862 100.415C206.941 100.312 207.058 100.24 207.215 100.201C207.371 100.162 207.566 100.166 207.798 100.215C207.96 100.249 208.119 100.303 208.276 100.379C208.432 100.454 208.567 100.544 208.679 100.647L208.55 100.94C208.435 100.841 208.312 100.76 208.182 100.695C208.051 100.628 207.923 100.581 207.798 100.555C207.576 100.509 207.409 100.515 207.297 100.574C207.187 100.634 207.132 100.729 207.132 100.86C207.132 100.956 207.164 101.041 207.226 101.116C207.289 101.187 207.366 101.25 207.457 101.304C207.551 101.355 207.678 101.417 207.837 101.487C208.043 101.581 208.209 101.666 208.335 101.743C208.46 101.82 208.567 101.92 208.656 102.042C208.747 102.165 208.793 102.315 208.793 102.491C208.793 102.637 208.753 102.764 208.675 102.87C208.597 102.974 208.478 103.045 208.319 103.084C208.16 103.12 207.964 103.114 207.732 103.065ZM209.734 100.999L208.794 100.803V100.455L211.061 100.929V101.277L210.121 101.08V103.532L209.734 103.451V100.999ZM212.959 103.425L211.502 103.121L211.201 103.758L210.798 103.674L212.039 101.133L212.427 101.214L213.672 104.274L213.261 104.188L212.959 103.425ZM212.822 103.076L212.231 101.581L211.64 102.829L212.822 103.076ZM214.35 101.964L213.41 101.767V101.419L215.677 101.893V102.241L214.738 102.045V104.497L214.35 104.416V101.964ZM217.053 105.012C216.687 104.936 216.403 104.77 216.199 104.514C215.995 104.258 215.894 103.93 215.894 103.53V101.938L216.285 102.02V103.596C216.285 104.196 216.542 104.55 217.056 104.657C217.307 104.709 217.499 104.676 217.632 104.557C217.765 104.436 217.832 104.223 217.832 103.919V102.343L218.212 102.422V104.014C218.212 104.417 218.11 104.704 217.906 104.875C217.703 105.043 217.418 105.089 217.053 105.012ZM219.676 105.56C219.47 105.517 219.27 105.444 219.077 105.339C218.886 105.233 218.736 105.116 218.627 104.989L218.772 104.707C218.876 104.825 219.009 104.932 219.171 105.027C219.335 105.12 219.504 105.184 219.676 105.22C219.903 105.268 220.073 105.265 220.185 105.211C220.297 105.154 220.353 105.061 220.353 104.93C220.353 104.834 220.322 104.75 220.259 104.678C220.199 104.604 220.124 104.542 220.032 104.491C219.944 104.44 219.817 104.378 219.653 104.303C219.446 104.21 219.279 104.124 219.151 104.047C219.026 103.97 218.918 103.87 218.826 103.747C218.738 103.622 218.693 103.47 218.693 103.291C218.693 103.142 218.731 103.015 218.807 102.911C218.885 102.807 219.003 102.736 219.159 102.696C219.316 102.657 219.51 102.662 219.743 102.71C219.904 102.744 220.064 102.799 220.22 102.874C220.377 102.949 220.511 103.039 220.624 103.142L220.494 103.435C220.379 103.337 220.257 103.255 220.126 103.19C219.996 103.123 219.868 103.076 219.743 103.05C219.521 103.004 219.354 103.01 219.241 103.07C219.132 103.129 219.077 103.225 219.077 103.355C219.077 103.451 219.108 103.536 219.171 103.611C219.234 103.683 219.311 103.745 219.402 103.799C219.496 103.851 219.622 103.912 219.782 103.982C219.988 104.076 220.154 104.161 220.279 104.238C220.404 104.315 220.511 104.415 220.6 104.537C220.691 104.66 220.737 104.81 220.737 104.986C220.737 105.133 220.698 105.259 220.62 105.365C220.541 105.469 220.423 105.54 220.263 105.579C220.104 105.615 219.908 105.609 219.676 105.56ZM223.155 103.455C223.51 103.529 223.79 103.674 223.993 103.89C224.197 104.106 224.299 104.366 224.299 104.67C224.299 104.974 224.197 105.192 223.993 105.322C223.79 105.453 223.51 105.481 223.155 105.407L222.478 105.266V106.114L222.087 106.032V103.232L223.155 103.455ZM223.144 105.057C223.392 105.109 223.581 105.095 223.711 105.015C223.842 104.933 223.907 104.791 223.907 104.588C223.907 104.386 223.842 104.217 223.711 104.083C223.581 103.947 223.392 103.853 223.144 103.801L222.478 103.662V104.918L223.144 105.057ZM228.583 104.589L227.666 107.198L227.255 107.112L226.507 104.72L225.76 106.799L225.341 106.712L224.424 103.72L224.828 103.805L225.568 106.235L226.339 104.12L226.699 104.196L227.455 106.641L228.211 104.511L228.583 104.589ZM230.757 107.843L230.166 106.86C230.093 106.85 230.035 106.841 229.993 106.832L229.316 106.69V107.542L228.925 107.46V104.66L229.993 104.884C230.348 104.958 230.628 105.103 230.831 105.319C231.035 105.535 231.137 105.795 231.137 106.099C231.137 106.315 231.085 106.488 230.98 106.618C230.876 106.748 230.727 106.828 230.534 106.857L231.184 107.932L230.757 107.843ZM229.982 106.489C230.23 106.541 230.419 106.526 230.549 106.444C230.68 106.362 230.745 106.22 230.745 106.017C230.745 105.814 230.68 105.646 230.549 105.512C230.419 105.375 230.23 105.281 229.982 105.229L229.316 105.09V106.35L229.982 106.489Z"
        fill="white"
      />
      <path
        d="M210.768 77.7783V80.5783L210.377 80.4965V79.2485L208.803 78.9197V80.1677L208.411 80.0859V77.2859L208.803 77.3677V78.5717L210.377 78.9005V77.6965L210.768 77.7783ZM211.315 77.8924L212.47 78.1337C212.759 78.1943 213.016 78.3067 213.241 78.4709C213.465 78.6351 213.639 78.8367 213.762 79.0757C213.887 79.3125 213.95 79.5683 213.95 79.8429C213.95 80.1176 213.887 80.3485 213.762 80.5357C213.639 80.7207 213.465 80.8485 213.241 80.9189C213.016 80.9893 212.759 80.9943 212.47 80.9337L211.315 80.6924V77.8924ZM212.446 80.5808C212.668 80.6272 212.862 80.6238 213.03 80.5707C213.199 80.5182 213.33 80.4228 213.421 80.2845C213.512 80.1436 213.558 79.9691 213.558 79.7611C213.558 79.5531 213.512 79.3609 213.421 79.1845C213.33 79.0054 213.199 78.8542 213.03 78.7307C212.862 78.6078 212.668 78.5232 212.446 78.4768L211.706 78.3222V80.4262L212.446 80.5808ZM214.275 78.511L215.43 78.7523C215.72 78.8128 215.977 78.9252 216.202 79.0894C216.426 79.2537 216.6 79.4553 216.722 79.6942C216.848 79.9311 216.91 80.1868 216.91 80.4615C216.91 80.7361 216.848 80.9671 216.722 81.1542C216.6 81.3393 216.426 81.467 216.202 81.5374C215.977 81.6079 215.72 81.6128 215.43 81.5523L214.275 81.311V78.511ZM215.407 81.1994C215.629 81.2457 215.823 81.2424 215.99 81.1893C216.16 81.1367 216.29 81.0413 216.382 80.9031C216.473 80.7621 216.519 80.5877 216.519 80.3797C216.519 80.1717 216.473 79.9795 216.382 79.8031C216.29 79.624 216.16 79.4727 215.99 79.3493C215.823 79.2264 215.629 79.1417 215.407 79.0954L214.667 78.9408V81.0448L215.407 81.1994Z"
        fill="white"
      />
      <path
        d="M332.391 74.771L332.39 178.017"
        stroke="#3C3636"
        strokeWidth="1.68702"
      />
      <defs>
        <filter
          id="filter0_d_2520_209293"
          x="0.564885"
          y="16"
          width="549.24"
          height="196.74"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8.43511" dy="16.8702" />
          <feGaussianBlur stdDeviation="8.43511" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.493507 0 0 0 0 0.508333 0 0 0 0 0.50648 0 0 0 0.39 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2520_209293"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2520_209293"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2520_209293"
          x1="95.5414"
          y1="124.912"
          x2="551.851"
          y2="147.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#525151" />
          <stop offset="0.44313" stopColor="#7E7E7E" />
          <stop offset="1" stopColor="#ABABAB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2520_209293"
          x1="95.5414"
          y1="124.912"
          x2="551.851"
          y2="147.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#525151" />
          <stop offset="0.44313" stopColor="#7E7E7E" />
          <stop offset="1" stopColor="#ABABAB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2520_209293"
          x1="304"
          y1="120.5"
          x2="107"
          y2="81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#858585" />
          <stop offset="1" stopColor="#585858" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2520_209293"
          x1="304"
          y1="120.5"
          x2="107"
          y2="81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#858585" />
          <stop offset="1" stopColor="#585858" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AaeonDeviceFront;
